import { useState, useCallback } from "react";

export function useActivityDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);

  const openAddDialog = useCallback((defaults = {}) => {
    setEditingGroup({
      groupId: null,
      name: "",
      campus: defaults.campus ?? "",
      slot: defaults.slot ?? "AFTERNOON",
      capacity: "",
      leaderStaffId: "",
      productId: "",
      activityKind: "PRODUCT",
      ratioChildrenPerAdult: "",
      dates: defaults.date ? [defaults.date] : [],
      notes: "",
    });
    setDialogOpen(true);
  }, []);

  const openEditDialog = useCallback((group) => {
    setEditingGroup(group || null);
    setDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogOpen(false);
    setEditingGroup(null);
  }, []);

  return {
    dialogOpen,
    editingGroup,
    openAddDialog,
    openEditDialog,
    closeDialog,
  };
}

export default useActivityDialog;